export const handleError = (error) => {
    console.log(error);
    return Promise.reject(new Error(error));
};


export const formatarValorReal = (valor) => {
    return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
}
export const formatarValorNormal = (valor) => {

    return Intl.NumberFormat('pt-BR').format(valor ? valor : 0)
}